import { createTheme, adaptV4Theme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import { components, palette, typography } from '@utriper/core-ui';

import overrides from './overrides';

// palette, typography and components are @utriper/core-ui's, generated from the design system's tokens.json
// (com.utriper.core-ui/design-system, `npm run gen:theme`). Only what is this app's own stays here: the legacy
// `overrides` block, which adaptV4Theme turns into `components`, and `inputs`.
const v4 = adaptV4Theme({
  palette,
  typography,
  overrides,
  inputs: {
    minHeight: 104,
  },
});

export default createTheme({
  ...v4,
  // core-ui's component overrides travel with its palette (contained secondary buttons rest on a darker blue
  // for AA contrast). Merged over the v4 ones so both apply.
  components: deepmerge(v4.components, components),
});
